import { inject, Injectable } from '@angular/core';
import { LoginService } from '../login.service';
import { MsalService } from '@azure/msal-angular';
import { ENTRA_LOGIN_CONFIG } from '../dual-login/dual-login.ui-service';
import { LoginIssuerStore } from '../login-issuer.store';

@Injectable()
export class EntraLoginService extends LoginService {
  private readonly msal = inject(MsalService);
  private readonly entraConfig = inject(ENTRA_LOGIN_CONFIG);
  private readonly issuerStore = inject(LoginIssuerStore);

  loginWithRedirect(): void {
    this.issuerStore.set('entra');
    // Guard the audience so a misconfigured app never requests `undefined/.default`.
    const audience = this.entraConfig.audience;
    this.msal.loginRedirect({
      scopes: audience ? [`${audience}/.default`] : [],
      prompt: 'select_account',
    });
  }
}
